<template>
    <div class="flex-col h-100">
        <!-- <keep-alive> -->
            <router-view></router-view>
            <!-- <router-view v-if='$route.meta.keepAlive'></router-view> -->
        <!-- </keep-alive>
        <router-view v-if='!$route.meta.keepAlive'></router-view> -->
        <van-tabbar route v-model="active" active-color="#C52A1A" inactive-color="#7D7D7D">
            <van-tabbar-item name="home" to="/home/overview">
                <span>{{ $t('common.home') }}</span>
                <template #icon="props">
                    <span class="iconfont iconhome-outline" v-if="!props.active"></span>
                    <span class="iconfont iconhome-fill" v-if="props.active"></span>
                </template>
            </van-tabbar-item>
            <van-tabbar-item name="search" to="/home/searchHome">
                <span>{{ $t('common.search') }}</span>
                <template #icon="props">
                    <span class="iconfont iconsearch-outline" v-if="!props.active"></span>
                    <span class="iconfont iconsearch-fill" v-if="props.active"></span>
                </template>
            </van-tabbar-item>
            <van-tabbar-item name="add" to="/home/addRelationship">
                <span>{{ $t('common.add') }}</span>
                <template #icon="props">
                    <span class="iconfont iconcircle-plus-outline" v-if="!props.active"></span>
                    <span class="iconfont iconcircle-plus-fill" v-if="props.active"></span>
                </template>
            </van-tabbar-item>
            <van-tabbar-item name="user" to="/home/userInfo">
                <span>{{ $t('common.userInfo') }}</span>
                <template #icon="props">
                    <span class="iconfont iconperson-outline" v-if="!props.active"></span>
                    <span class="iconfont iconperson-fill" v-if="props.active"></span>
                </template>
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
import _ from "lodash";
import { Toast, Notify } from "vant";
import AddRelationship from "./add/AddRelationship";
import UserInfo from "./profile/UserInfo";
export default {
    name: "overview",
    components: {
        Toast,
        AddRelationship,
        UserInfo,
    },
    data() {
        return {
            active: "home",
        };
    },
    created() {},
    methods: {},
};
</script>


<style lang="scss" scoped>
@import "../styles/theme.scss";
/deep/ .van-tabbar {
    border: 2px solid #f9f7f7;
    height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/views/Home.vue